import { ValidationErrors, Validators } from "@angular/forms";
import { DynamicFormControlType } from '@waseel-asp/tpa-waseel-lib-staging';

// For System Settings
export enum SettingsName {
    SmsProvider = 'smsprovider',
    AdjudicationInterval = 'adjudicationinterval',
    ChartType = 'charttype',
    ChartSummary = 'chartsummary',
    SuperSetCharts = 'SuperSetCharts',
    ResetPasswordExpMinutes = 'resetpasswordexpminutes',
    SendOTPExpMinutes = 'sendotpexpminutes',
    UseDefaultSMSNumber = 'usedefaultsmsnumber',
    EnableNotification = 'enablenotification',
    ReconciliationIntervalMonths = 'reconciliationintervalmonths',
    LanguagePreference = 'languagepreference',
    SMSDefaultNumber = 'smsdefaultnumber',
    UseDefaultEmailAddress = 'usedefaultemailaddress',
    PaymentIntervalMonths = 'paymentintervalmonths',
    EmailConfiguration = 'emailconfiguration',
    PBMConfiguration = 'pbmconfiguration',
    ApprovalHighCostEscalation = 'approvalhighcostescalation',
    ApprovalAutoAssignment = 'approvalautoassignment',
    SLATimerMinutes = 'slatimerminutes'
}

export const settingInputTypeMap: { [key in SettingsName]: DynamicFormControlType } = {
    [SettingsName.SmsProvider]: DynamicFormControlType.DropDown,
    [SettingsName.AdjudicationInterval]: DynamicFormControlType.Number,
    [SettingsName.ChartType]: DynamicFormControlType.Radiobutton,
    [SettingsName.ChartSummary]: DynamicFormControlType.SlideToggle,
    [SettingsName.SuperSetCharts]: DynamicFormControlType.Radiobutton,
    [SettingsName.ResetPasswordExpMinutes]: DynamicFormControlType.Number,
    [SettingsName.SendOTPExpMinutes]: DynamicFormControlType.Number,
    [SettingsName.UseDefaultSMSNumber]: DynamicFormControlType.SlideToggle,
    [SettingsName.EnableNotification]: DynamicFormControlType.SlideToggle,
    [SettingsName.ReconciliationIntervalMonths]: DynamicFormControlType.Number,
    [SettingsName.LanguagePreference]: DynamicFormControlType.DropDown,
    [SettingsName.SMSDefaultNumber]: DynamicFormControlType.ContactNumber,
    [SettingsName.UseDefaultEmailAddress]: DynamicFormControlType.SlideToggle,
    [SettingsName.PaymentIntervalMonths]: DynamicFormControlType.Number,
    [SettingsName.EmailConfiguration]: DynamicFormControlType.SlideToggle,
    [SettingsName.PBMConfiguration]: DynamicFormControlType.SlideToggle,
    [SettingsName.ApprovalHighCostEscalation]: DynamicFormControlType.Number,
    [SettingsName.ApprovalAutoAssignment]: DynamicFormControlType.SlideToggle,
    [SettingsName.SLATimerMinutes]: DynamicFormControlType.Number
};

export const settingDisplayNames: { [key in SettingsName]: string } = {
    [SettingsName.SmsProvider]: 'SETTINGS.DISPLAY_NAME.SMS_PROVIDER',
    [SettingsName.AdjudicationInterval]: 'SETTINGS.DISPLAY_NAME.ADJUDICATION_INTERVAL',
    [SettingsName.ChartType]: 'DASHBOARD.CHART_TYPE',
    [SettingsName.ChartSummary]: 'SETTINGS.DISPLAY_NAME.CHART_SUMMARY',
    [SettingsName.SuperSetCharts]: 'SETTINGS.DISPLAY_NAME.SUPERSET_CHART_SUMMARY',
    [SettingsName.ResetPasswordExpMinutes]: 'SETTINGS.DISPLAY_NAME.RESET_PASSWORD_EXP_MINUTES',
    [SettingsName.SendOTPExpMinutes]: 'SETTINGS.DISPLAY_NAME.SEND_OTP_EXP_MINUTES',
    [SettingsName.UseDefaultSMSNumber]: 'SETTINGS.DISPLAY_NAME.USE_DEFAULT_SMS_NUMBER',
    [SettingsName.EnableNotification]: 'SETTINGS.DISPLAY_NAME.ENABLE_NOTIFICATION',
    [SettingsName.ReconciliationIntervalMonths]: 'SETTINGS.DISPLAY_NAME.RECONCILIATION_INTERVAL_MONTHS',
    [SettingsName.LanguagePreference]: 'SETTINGS.DISPLAY_NAME.LANGUAGE_PREFERENCE',
    [SettingsName.SMSDefaultNumber]: 'SETTINGS.DISPLAY_NAME.SMS_DEFAULT_NUMBER',
    [SettingsName.UseDefaultEmailAddress]: 'SETTINGS.DISPLAY_NAME.USE_DEFAULT_EMAIL_ADDRESS',
    [SettingsName.PaymentIntervalMonths]: 'SETTINGS.DISPLAY_NAME.PAYMENT_INTERVAL_MONTHS',
    [SettingsName.EmailConfiguration]: 'SETTINGS.DISPLAY_NAME.EMAIL_CONFIGURATION',
    [SettingsName.PBMConfiguration]: 'SETTINGS.DISPLAY_NAME.PBM_CONFIGURATION',
    [SettingsName.ApprovalHighCostEscalation]: 'SETTINGS.DISPLAY_NAME.APPROVAL_HIGH_COST_ESCALATION_CONFIGURATION',
    [SettingsName.ApprovalAutoAssignment]: 'SETTINGS.DISPLAY_NAME.APPROVAL_AUTO_ASSIGN_CONFIGURATION',
    [SettingsName.SLATimerMinutes]: 'SETTINGS.DISPLAY_NAME.SLA_TIMER_CONFIGURATION'
};

export const settingInputLabel: { [key in SettingsName]: string } = {
    [SettingsName.SmsProvider]: 'SETTINGS.INPUT_LABEL_NAME.SMS_PROVIDER',
    [SettingsName.AdjudicationInterval]: 'SETTINGS.INPUT_LABEL_NAME.ADJUDICATION_INTERVAL',
    [SettingsName.ChartType]: 'DASHBOARD.CHART_TYPE',
    [SettingsName.ChartSummary]: 'SETTINGS.INPUT_LABEL_NAME.CHART_SUMMARY',
    [SettingsName.SuperSetCharts]: 'SETTINGS.INPUT_LABEL_NAME.SUPERSET_CHART_SUMMARY',
    [SettingsName.ResetPasswordExpMinutes]: 'SETTINGS.INPUT_LABEL_NAME.RESET_PASSWORD_EXP_MINUTES',
    [SettingsName.SendOTPExpMinutes]: 'SETTINGS.INPUT_LABEL_NAME.SEND_OTP_EXP_MINUTES',
    [SettingsName.UseDefaultSMSNumber]: 'SETTINGS.INPUT_LABEL_NAME.USE_DEFAULT_SMS_NUMBER',
    [SettingsName.EnableNotification]: 'SETTINGS.INPUT_LABEL_NAME.ENABLE_NOTIFICATION',
    [SettingsName.ReconciliationIntervalMonths]: 'SETTINGS.INPUT_LABEL_NAME.RECONCILIATION_INTERVAL_MONTHS',
    [SettingsName.LanguagePreference]: 'SETTINGS.INPUT_LABEL_NAME.LANGUAGE_PREFERENCE',
    [SettingsName.SMSDefaultNumber]: 'SETTINGS.INPUT_LABEL_NAME.SMS_DEFAULT_NUMBER',
    [SettingsName.UseDefaultEmailAddress]: 'SETTINGS.DISPLAY_NAME.USE_DEFAULT_EMAIL_ADDRESS',
    [SettingsName.PaymentIntervalMonths]: 'SETTINGS.INPUT_LABEL_NAME.PAYMENT_INTERVAL_MONTHS',
    [SettingsName.EmailConfiguration]: 'SETTINGS.INPUT_LABEL_NAME.EMAIL_CONFIGURATION',
    [SettingsName.PBMConfiguration]: 'SETTINGS.INPUT_LABEL_NAME.PBM_CONFIGURATION',
    [SettingsName.ApprovalHighCostEscalation]: 'SETTINGS.INPUT_LABEL_NAME.APPROVAL_HIGH_COST_ESCALATION_CONFIGURATION',
    [SettingsName.ApprovalAutoAssignment]: 'SETTINGS.INPUT_LABEL_NAME.APPROVAL_AUTO_ASSIGN_CONFIGURATION',
    [SettingsName.SLATimerMinutes]: 'SETTINGS.INPUT_LABEL_NAME.SLA_TIMER_MINUTES'
};

export const settingDescription: { [key in SettingsName]: string } = {
    [SettingsName.SmsProvider]: 'SETTINGS.DESCRIPTION.SMS_PROVIDER',
    [SettingsName.AdjudicationInterval]: 'SETTINGS.DESCRIPTION.ADJUDICATION_INTERVAL',
    [SettingsName.ChartType]: 'SETTINGS.DESCRIPTION.CHART_TYPE',
    [SettingsName.ChartSummary]: 'SETTINGS.DESCRIPTION.CHART_SUMMARY',
    [SettingsName.SuperSetCharts]: 'SETTINGS.DESCRIPTION.SUPERSET_CHART_SUMMARY',
    [SettingsName.ResetPasswordExpMinutes]: 'SETTINGS.DESCRIPTION.RESET_PASSWORD_EXP_MINUTES',
    [SettingsName.SendOTPExpMinutes]: 'SETTINGS.DESCRIPTION.SEND_OTP_EXP_MINUTES',
    [SettingsName.UseDefaultSMSNumber]: 'SETTINGS.DESCRIPTION.USE_DEFAULT_SMS_NUMBER',
    [SettingsName.EnableNotification]: 'SETTINGS.DESCRIPTION.ENABLE_NOTIFICATION',
    [SettingsName.ReconciliationIntervalMonths]: 'SETTINGS.DESCRIPTION.RECONCILIATION_INTERVAL_MONTHS',
    [SettingsName.LanguagePreference]: 'SETTINGS.DESCRIPTION.LANGUAGE_PREFERENCE',
    [SettingsName.SMSDefaultNumber]: 'SETTINGS.DESCRIPTION.SMS_DEFAULT_NUMBER',
    [SettingsName.UseDefaultEmailAddress]: 'SETTINGS.DESCRIPTION.USE_DEFAULT_EMAIL_ADDRESS',
    [SettingsName.PaymentIntervalMonths]: 'SETTINGS.DESCRIPTION.PAYMENT_INTERVAL_MONTHS',
    [SettingsName.EmailConfiguration]: 'SETTINGS.DESCRIPTION.EMAIL_CONFIGURATION',
    [SettingsName.PBMConfiguration]: 'SETTINGS.DESCRIPTION.PBM_CONFIGURATION',
    [SettingsName.ApprovalHighCostEscalation]: 'SETTINGS.DESCRIPTION.APPROVAL_HIGH_COST_ESCALATION_CONFIGURATION',
    [SettingsName.ApprovalAutoAssignment]: 'SETTINGS.DESCRIPTION.APPROVAL_AUTO_ASSIGN_CONFIGURATION',
    [SettingsName.SLATimerMinutes]: 'SETTINGS.DESCRIPTION.SLA_TIMER_CONFIGURATION'
};

export const settingInputValidators: { [key in SettingsName]: ValidationErrors[] } = {
    [SettingsName.SmsProvider]: [Validators.required],
    [SettingsName.AdjudicationInterval]: [Validators.required, Validators.min(1), Validators.max(365)],
    [SettingsName.ChartType]: [],
    [SettingsName.ChartSummary]: [Validators.required],
    [SettingsName.SuperSetCharts]: [Validators.required],
    [SettingsName.ResetPasswordExpMinutes]: [Validators.required, Validators.min(1), Validators.max(180)],
    [SettingsName.SendOTPExpMinutes]: [Validators.required, Validators.min(1), Validators.max(30)],
    [SettingsName.UseDefaultSMSNumber]: [Validators.required],
    [SettingsName.EnableNotification]: [Validators.required],
    [SettingsName.ReconciliationIntervalMonths]: [Validators.required, Validators.min(1), Validators.max(12)],
    [SettingsName.LanguagePreference]: [Validators.required],
    [SettingsName.SMSDefaultNumber]: [Validators.required],
    [SettingsName.UseDefaultEmailAddress]: [Validators.required],
    [SettingsName.PaymentIntervalMonths]: [Validators.required, Validators.min(1), Validators.max(12)],
    [SettingsName.EmailConfiguration]: [Validators.required],
    [SettingsName.PBMConfiguration]: [Validators.required],
    [SettingsName.ApprovalHighCostEscalation]: [Validators.required],
    [SettingsName.ApprovalAutoAssignment]: [Validators.required],
    [SettingsName.SLATimerMinutes]: [Validators.required]
};

// For System Sub-settings
export enum SubSettingsName {
    ClaimActiveInActiveSummary = 'claimactiveinactivesummary',
    ClaimSummary = 'claimsummary',
    ConvertSummary = 'convertsummary',
    DenialResponseSummary = 'denialresponsesummary',
    DenialSummary = 'denialsummary',
    EligibilitySummary = 'eligibilitysummary',
    EligibleNonEligibleSummary = 'eligiblenoneligiblesummary',
    PaymentCompletionSummary = 'paymentcompletionsummary',
    PaymentSummary = 'paymentsummary',
    PreAuthorizationSummary = 'preauthorizationsummary',
    PrescriptionSummary = 'prescriptionsummary',
    ReconciliationSummary = 'reconciliationsummary',
    SMSDefaultNumber = 'smsdefaultnumber',
    DefaultEmailAddress = 'defaultemailaddress',
    SenderEmail = 'senderemail',
    SenderUserName = 'senderusername',
    SenderPassword = 'senderpassword',
    SmtpServer = 'smtpserver',
    SmtpPort = 'smtpport',
    PBMPrescriptionAccessToken = 'pbmprescriptionaccesstoken',
    PBMApprovalUserName = 'pbmapprovalusername',
    PBMApprovalPassword = 'pbmapprovalpassword'
}

export const subSettingInputTypeMap: { [key in SubSettingsName]: DynamicFormControlType } = {
    [SubSettingsName.ClaimActiveInActiveSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.ClaimSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.ConvertSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.DenialResponseSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.DenialSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.EligibilitySummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.EligibleNonEligibleSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.PaymentCompletionSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.PaymentSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.PreAuthorizationSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.PrescriptionSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.ReconciliationSummary]: DynamicFormControlType.SlideToggle,
    [SubSettingsName.SMSDefaultNumber]: DynamicFormControlType.ContactNumber,
    [SubSettingsName.DefaultEmailAddress]: DynamicFormControlType.Email,
    [SubSettingsName.SenderEmail]: DynamicFormControlType.Email,
    [SubSettingsName.SenderUserName]: DynamicFormControlType.Text,
    [SubSettingsName.SenderPassword]: DynamicFormControlType.Password,
    [SubSettingsName.SmtpServer]: DynamicFormControlType.Text,
    [SubSettingsName.SmtpPort]: DynamicFormControlType.Number,
    [SubSettingsName.PBMPrescriptionAccessToken]: DynamicFormControlType.Text,
    [SubSettingsName.PBMApprovalUserName]: DynamicFormControlType.Text,
    [SubSettingsName.PBMApprovalPassword]: DynamicFormControlType.Password
};

export const subSettingInputLabel: { [key in SubSettingsName]: string } = {
    [SubSettingsName.ClaimActiveInActiveSummary]: 'SETTINGS.DISPLAY_NAME.CLAIM_ACTIVE_IN_ACTIVE_SUMMARY',
    [SubSettingsName.ClaimSummary]: 'SETTINGS.DISPLAY_NAME.CLAIM_SUMMARY',
    [SubSettingsName.ConvertSummary]: 'SETTINGS.DISPLAY_NAME.CONVERT_SUMMARY',
    [SubSettingsName.DenialResponseSummary]: 'SETTINGS.DISPLAY_NAME.DENIAL_RESPONSE_SUMMARY',
    [SubSettingsName.DenialSummary]: 'SETTINGS.DISPLAY_NAME.DENIAL_SUMMARY',
    [SubSettingsName.EligibilitySummary]: 'SETTINGS.DISPLAY_NAME.ELIGIBILITY_SUMMARY',
    [SubSettingsName.EligibleNonEligibleSummary]: 'SETTINGS.DISPLAY_NAME.ELIGIBLE_NON_ELIGIBLE_SUMMARY',
    [SubSettingsName.PaymentCompletionSummary]: 'SETTINGS.DISPLAY_NAME.PAYMENT_COMPLETION_SUMMARY',
    [SubSettingsName.PaymentSummary]: 'SETTINGS.DISPLAY_NAME.PAYMENT_SUMMARY',
    [SubSettingsName.PreAuthorizationSummary]: 'SETTINGS.DISPLAY_NAME.PRE_AUTHORIZATION_SUMMARY',
    [SubSettingsName.PrescriptionSummary]: 'SETTINGS.DISPLAY_NAME.PRESCRIPTION_SUMMARY',
    [SubSettingsName.ReconciliationSummary]: 'SETTINGS.DISPLAY_NAME.RECONCILIATION_SUMMARY',
    [SubSettingsName.SMSDefaultNumber]: 'SETTINGS.INPUT_LABEL_NAME.SMS_DEFAULT_NUMBER',
    [SubSettingsName.DefaultEmailAddress]: 'FORM_FIELD.EMAIL',
    [SubSettingsName.SenderEmail]: 'FORM_FIELD.EMAIL',
    [SubSettingsName.SenderPassword]: 'COMMON.PASSWORD',
    [SubSettingsName.SmtpServer]: 'SETTINGS.INPUT_LABEL_NAME.SMTP_SERVER',
    [SubSettingsName.SenderUserName]: 'SETTINGS.INPUT_LABEL_NAME.SMTP_USER_NAME',
    [SubSettingsName.SmtpPort]: 'SETTINGS.INPUT_LABEL_NAME.SMTP_PORT',
    [SubSettingsName.PBMPrescriptionAccessToken]: 'SETTINGS.INPUT_LABEL_NAME.PBM_PRESCRIPTION_ACCESS_TOKEN',
    [SubSettingsName.PBMApprovalUserName]: 'SETTINGS.INPUT_LABEL_NAME.PBM_APPROVAL_USER_NAME',
    [SubSettingsName.PBMApprovalPassword]: 'SETTINGS.INPUT_LABEL_NAME.PBM_APPROVAL_PASSWORD'
};

//ts-prune-ignore-next
export const subSettingInputValidators: { [key in SubSettingsName]: ValidationErrors[] } = {
    [SubSettingsName.ClaimActiveInActiveSummary]: [Validators.required],
    [SubSettingsName.ClaimSummary]: [Validators.required],
    [SubSettingsName.ConvertSummary]: [Validators.required],
    [SubSettingsName.DenialResponseSummary]: [Validators.required],
    [SubSettingsName.DenialSummary]: [Validators.required],
    [SubSettingsName.EligibilitySummary]: [Validators.required],
    [SubSettingsName.EligibleNonEligibleSummary]: [Validators.required],
    [SubSettingsName.PaymentCompletionSummary]: [Validators.required],
    [SubSettingsName.PaymentSummary]: [Validators.required],
    [SubSettingsName.PreAuthorizationSummary]: [Validators.required],
    [SubSettingsName.PrescriptionSummary]: [Validators.required],
    [SubSettingsName.ReconciliationSummary]: [Validators.required],
    [SubSettingsName.SMSDefaultNumber]: [Validators.required],
    [SubSettingsName.DefaultEmailAddress]: [Validators.required, Validators.maxLength(40)],
    [SubSettingsName.SenderEmail]: [Validators.required, Validators.maxLength(40)],
    [SubSettingsName.SenderUserName]: [Validators.required, Validators.maxLength(300)],
    [SubSettingsName.SenderPassword]: [Validators.required],
    [SubSettingsName.SmtpServer]: [Validators.required],
    [SubSettingsName.SmtpPort]: [Validators.required],
    [SubSettingsName.PBMPrescriptionAccessToken]: [Validators.required],
    [SubSettingsName.PBMApprovalUserName]: [Validators.required],
    [SubSettingsName.PBMApprovalPassword]: [Validators.required]
};

export enum ChartType {
    TPA = 'TPASystem',
    Dynamic = 'SuperSet'
}

export const settingsOrder: Record<string, number> = {
    [SettingsName.LanguagePreference]: 1,
    [SettingsName.ResetPasswordExpMinutes]: 2,
    [SettingsName.SendOTPExpMinutes]: 3,
    [SettingsName.ChartType]: 4,
    [SettingsName.ChartSummary]: 5,
    [SettingsName.SuperSetCharts]: 6,
    [SettingsName.EmailConfiguration]: 7,
    [SettingsName.SmsProvider]: 8,
    [SettingsName.UseDefaultEmailAddress]: 9,
    [SettingsName.UseDefaultSMSNumber]: 10,
    [SettingsName.SMSDefaultNumber]: 11,
    [SettingsName.EnableNotification]: 12,
    [SettingsName.PBMConfiguration]: 13,
    [SettingsName.AdjudicationInterval]: 14,
    [SettingsName.ApprovalAutoAssignment]: 15,
    [SettingsName.PaymentIntervalMonths]: 16,
    [SettingsName.ApprovalHighCostEscalation]: 17,
    [SettingsName.ReconciliationIntervalMonths]: 18,
    [SettingsName.SLATimerMinutes]: 19
};